import { SelectOption } from '@indigo-ag/component-module';
import i18next from 'i18next';
import { text } from './text.util';

type Enum<EnumType> = Record<keyof EnumType, number | string> & { [k: number]: string };

// see https://github.com/Microsoft/TypeScript/issues/3192#issuecomment-261720275
export function makeEnum<T extends { [index: string]: U }, U extends string>(x: T) {
  return x;
}

/**
 *
 * @param item Should be an ENUM or Object
 * @description is useful to transform objects or enums into options that
 * Select component can display
 * @returns Array of select options
 */
export const generateOptionsFromEnum = <EnumType extends Enum<EnumType>>(item: EnumType): SelectOption[] =>
  Object.entries(item).map(([name, value]) => ({
    name: text.firstLetterUppercase(i18next.t(`${name}`.toLocaleLowerCase())),
    value
  }));
